import { z } from "zod";

export enum EhrLookupDecision {
  INSUFFICIENT_EVIDENCE = "insufficient_evidence",
  MATCH = "match",
  NO_MATCH = "no_match",
}

export enum EhrLookupOutcome {
  DECLINED = "declined",
  DETAILS_ONLY = "details_only",
  ERROR = "error",
  MATCHED_LOCAL = "matched_local",
  NEW_CHART = "new_chart",
  NO_CANDIDATES = "no_candidates",
}

export const ehrLookupJudgementSchema = z
  .object({
    reasoning: z.string(),
    decision: z.enum(EhrLookupDecision),
    candidateId: z.string().nullable(),
    possibleDuplicateCharts: z.boolean(),
  })
  .strict();

export type EhrLookupJudgement = z.infer<typeof ehrLookupJudgementSchema>;

export const ehrLookupSchema = z.object({
  candidates: z.array(
    z.looseObject({ candidateId: z.string(), ehrSystemId: z.string().nullable(), mrn: z.string().nullable() })
  ),
  judgement: ehrLookupJudgementSchema.nullable(),
  outcome: z.enum(EhrLookupOutcome),
});

export type EhrLookup = z.infer<typeof ehrLookupSchema>;
